var map = {
	"./Authorize/modules/AuthorizeSagas": [
		"./src/routes/Authorize/modules/AuthorizeSagas.js",
		"Authorize-modules-AuthorizeSagas"
	],
	"./BookingManagement/modules/BookingManagementSagas": [
		"./src/routes/BookingManagement/modules/BookingManagementSagas.js",
		"BookingManagement-modules-BookingManagementSagas"
	],
	"./CardCheck/modules/CardCheckSagas": [
		"./src/routes/CardCheck/modules/CardCheckSagas.js",
		"CardCheck-modules-CardCheckSagas"
	],
	"./ChangePassword/modules/ChangePasswordSagas": [
		"./src/routes/ChangePassword/modules/ChangePasswordSagas.js",
		"ChangePassword-modules-ChangePasswordSagas"
	],
	"./CreatePayByLinkPlus/modules/CreatePayByLinkPlusSagas": [
		"./src/routes/CreatePayByLinkPlus/modules/CreatePayByLinkPlusSagas.js",
		"CreatePayByLinkPlus-modules-CreatePayByLinkPlusSagas"
	],
	"./Dashboard/modules/DashboardSagas": [
		"./src/routes/Dashboard/modules/DashboardSagas.js",
		"Dashboard-modules-DashboardSagas"
	],
	"./Login/modules/LoginSagas": [
		"./src/routes/Login/modules/LoginSagas.js",
		"Login-modules-LoginSagas"
	],
	"./Moto/modules/MotoSagas": [
		"./src/routes/Moto/modules/MotoSagas.js",
		"Moto-modules-MotoSagas"
	],
	"./OperationManagement/modules/OperationManagementSagas": [
		"./src/routes/OperationManagement/modules/OperationManagementSagas.js",
		"OperationManagement-modules-OperationManagementSagas"
	],
	"./OrderManagement/modules/OrderManagementSagas": [
		"./src/routes/OrderManagement/modules/OrderManagementSagas.js"
	],
	"./PayToCard/modules/PayToCardSagas": [
		"./src/routes/PayToCard/modules/PayToCardSagas.js",
		"PayToCard-modules-PayToCardSagas"
	],
	"./PblManagement/modules/PblManagementSagas": [
		"./src/routes/PblManagement/modules/PblManagementSagas.js",
		"PblManagement-modules-PblManagementSagas"
	],
	"./PointsOfSales/modules/PointsOfSalesSagas": [
		"./src/routes/PointsOfSales/modules/PointsOfSalesSagas.js",
		"PointsOfSales-modules-PointsOfSalesSagas"
	],
	"./Profile/modules/ProfileSagas": [
		"./src/routes/Profile/modules/ProfileSagas.js",
		"Profile-modules-ProfileSagas"
	],
	"./RecoveryCredentials/modules/RecoveryCredentialsSagas": [
		"./src/routes/RecoveryCredentials/modules/RecoveryCredentialsSagas.js",
		"RecoveryCredentials-modules-RecoveryCredentialsSagas"
	],
	"./Reports/modules/ReportsSagas": [
		"./src/routes/Reports/modules/ReportsSagas.js",
		"Reports-modules-ReportsSagas"
	],
	"./ResetPassword/modules/ResetPasswordSagas": [
		"./src/routes/ResetPassword/modules/ResetPasswordSagas.js",
		"ResetPassword-modules-ResetPasswordSagas"
	],
	"./SubscriptionPlan/modules/SubscriptionPlanSagas": [
		"./src/routes/SubscriptionPlan/modules/SubscriptionPlanSagas.js",
		"SubscriptionPlan-modules-SubscriptionPlanSagas"
	],
	"./TerminalsManagement/modules/TerminalsManagementSagas": [
		"./src/routes/TerminalsManagement/modules/TerminalsManagementSagas.js",
		"TerminalsManagement-modules-TerminalsManagementSagas"
	],
	"./Users/modules/UsersSagas": [
		"./src/routes/Users/modules/UsersSagas.js",
		"Users-modules-UsersSagas"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/routes lazy recursive ^\\.\\/.*\\/modules\\/.*Sagas$";
module.exports = webpackAsyncContext;